module.exports = "<div class=\"c-tabs\">\n    <ul class=\"c-tabs__list\">\n        <li class=\"c-tabs__el\" v-for=\"(tab, index) in tabs\">\n            <a @click=\"selectTab(index)\" class=\"c-tabs__link\" :class=\"{ 'c-tabs__link--capitalize': capitalize, 'is-selected': selected == index }\">{{tab.name}}</a>\n        </li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/tabs/tabs.vhtml
// module id = 247
// module chunks = 0